import React from "react";
import { Grid, makeStyles, Container, Link } from "@material-ui/core";
import NtkHeader from "../services/common/NtkHeader";
import NtkParagraph from "../services/common/NtkParagraph";
import NtkButton from "../services/common/NtkButton";

const useStyles = makeStyles((theme) => ({
  grid: {
    margin: "7.5em auto 3em auto",
    textAlign: "center",
  },
  btnContainer: {
    justifyContent: "center",
  },
  btn: {
    textDecoration: "none !important",
    margin: "2em",
    [theme.breakpoints.down("xs")]: {
      margin: "0.7em",
    },
  },
}));

const ReadyStartLearn = ({ header, paragraph }) => {
  const classes = useStyles();
  return (
    <Grid className={classes.grid}>
      <NtkHeader header={header} />
      <NtkParagraph paragraph={paragraph} />
      <Grid container className={classes.btnContainer}>
        <Grid item>
          <Link href={"/services/individuals"} className={classes.btn}>
            <NtkButton title={"Individuals"} />
          </Link>
        </Grid>
        <Grid item>
          <Link href={"/services/academic"} className={classes.btn}>
            <NtkButton title={"Academic"} />
          </Link>
        </Grid>
        <Grid item>
          <Link href={"/services/organizations"} className={classes.btn}>
            <NtkButton title={"Organizations"} />
          </Link>
        </Grid>
      </Grid>
    </Grid>
  );
};

export default ReadyStartLearn;
